export default "__VITE_ASSET__CZWw5NDh__"